var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progetti",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "progetti-2",
    "data-name": "progetti",
    transform: "translate(285.701 633.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3275",
    "data-name": "Raggruppa 3275",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, -24.494, 68.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_698_",
    d: "M212.251,39.512h3.214a19.5,19.5,0,0,0,2.907,7.023L216.1,48.81a2.081,2.081,0,0,0,0,2.943l2.474,2.474a2.081,2.081,0,0,0,2.943,0l2.275-2.275a19.318,19.318,0,0,0,7.023,2.907v3.214a2.077,2.077,0,0,0,2.076,2.076h3.5a2.077,2.077,0,0,0,2.076-2.076V54.859a19.5,19.5,0,0,0,7.023-2.907l2.275,2.275a2.081,2.081,0,0,0,2.943,0l2.474-2.474a2.081,2.081,0,0,0,0-2.943l-2.275-2.275a19.318,19.318,0,0,0,2.907-7.023h3.214a2.077,2.077,0,0,0,2.076-2.076V33.951a2.077,2.077,0,0,0-2.076-2.076h-3.214a19.5,19.5,0,0,0-2.907-7.023l2.275-2.275a2.081,2.081,0,0,0,0-2.943L250.69,17.16a2.081,2.081,0,0,0-2.943,0l-2.275,2.275a19.318,19.318,0,0,0-7.023-2.907V13.314a2.077,2.077,0,0,0-2.076-2.076h-3.5a2.077,2.077,0,0,0-2.076,2.076v3.214a19.5,19.5,0,0,0-7.023,2.907l-2.257-2.275a2.081,2.081,0,0,0-2.943,0L216.1,19.633a2.081,2.081,0,0,0,0,2.943l2.275,2.275a19.317,19.317,0,0,0-2.907,7.023h-3.214a2.077,2.077,0,0,0-2.076,2.076v3.5A2.061,2.061,0,0,0,212.251,39.512Zm22.37-12.675a8.865,8.865,0,1,1-8.865,8.865A8.869,8.869,0,0,1,234.621,26.837Z",
    transform: "translate(-183.824 -7.457)",
    fill: "#dedbdb",
    stroke: "#b8b8b8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_741",
    "data-name": "Rettangolo 741",
    width: 15,
    height: 14,
    transform: "translate(34 15.139)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3276",
    "data-name": "Raggruppa 3276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_698_2",
    "data-name": "XMLID_698_",
    d: "M211.817,33.6h2.542a15.426,15.426,0,0,0,2.3,5.555l-1.8,1.8a1.646,1.646,0,0,0,0,2.328l1.956,1.956a1.646,1.646,0,0,0,2.328,0l1.8-1.8a15.28,15.28,0,0,0,5.555,2.3v2.542a1.642,1.642,0,0,0,1.642,1.642h2.77a1.642,1.642,0,0,0,1.642-1.642V45.74a15.426,15.426,0,0,0,5.555-2.3l1.8,1.8a1.646,1.646,0,0,0,2.328,0l1.956-1.956a1.646,1.646,0,0,0,0-2.328l-1.8-1.8a15.28,15.28,0,0,0,2.3-5.555h2.542a1.642,1.642,0,0,0,1.642-1.642V29.2a1.642,1.642,0,0,0-1.642-1.642h-2.542a15.426,15.426,0,0,0-2.3-5.555l1.8-1.8a1.646,1.646,0,0,0,0-2.328l-1.971-1.956a1.646,1.646,0,0,0-2.328,0l-1.8,1.8a15.28,15.28,0,0,0-5.555-2.3V12.88a1.642,1.642,0,0,0-1.642-1.642h-2.77a1.642,1.642,0,0,0-1.642,1.642v2.542a15.426,15.426,0,0,0-5.555,2.3l-1.785-1.8a1.646,1.646,0,0,0-2.328,0l-1.956,1.956a1.646,1.646,0,0,0,0,2.328l1.8,1.8a15.28,15.28,0,0,0-2.3,5.555h-2.542a1.642,1.642,0,0,0-1.642,1.642v2.77A1.63,1.63,0,0,0,211.817,33.6Zm17.694-10.025a7.012,7.012,0,1,1-7.012,7.012A7.015,7.015,0,0,1,229.511,23.576Z",
    transform: "translate(-184.16 -7.801)",
    fill: "#bfd7ed",
    stroke: "#03518c",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.c1002d5e955068aa2ddbc1be6d7e330d.svg";
export { ForwardRef as ReactComponent };